<template>
  <div class="filter-add" v-if="itemsComp.length">
    <DropdownComponent :close-on-click="true" class="filter-add__dropdown">
      <ButtonComponent
        class="filter-add__trigger"
        :label="$t('addFilter')"
        :icon="['fal', 'plus']"
        icon-placement="right"
      />
      <template #dropdown>
        <template v-for="(item, index) in itemsComp">
          <ButtonComponent @click="$emit('add', item)" :label="getOptions(item).label || $tc(item.slice(0, -1), 2)" />
        </template>
      </template>
    </DropdownComponent>
  </div>
</template>

<script>
import { CheckboxComponent } from 'vue-elder-checkbox'
import { DropdownComponent } from 'vue-elder-dropdown'

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    itemsComp() {
      return this.items
        .filter(i => {
          let [component, alias] = i.split(':')
          if (!alias) alias = component

          return !Object.keys(this.filter).find(key => alias === key)
        })
        .filter(Boolean)
    },
  },
  methods: {
    getOptions(key) {
      let [component, alias] = key.split(':')
      if (!alias) alias = component

      return this.options[alias] || {}
    },
  },
  components: {
    CheckboxComponent,
    DropdownComponent,
  },
}
</script>

<style lang="scss">
.filter-add {
  &__trigger {
    border: none;
  }
}
</style>
